import { ICommonConfig } from '@/api/typings/system';
import { makeAutoObservable } from 'mobx';
import { apiGetSystemCommonConfig } from '@/api/system';

export default class SystemConfig {
  commonConfig: ICommonConfig = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setCommonConfig(commonConfig: ICommonConfig) {
    this.commonConfig = commonConfig;
  }

  async queryCommonConfig() {
    try {
      const { common = {} } = await apiGetSystemCommonConfig();

      this.setCommonConfig(common);
    } catch (e) {
      console.error(e);
    }
  }
}
